import React from "react";
import "./TermsAndCondition.scss";
import {MDBBox} from "mdbreact";
import BottomNav from "../../component/BottomNav/BottomNav";
import TermsAndConditionContent from "../../component/TermsAndConditionContent/TermsAndConditionContent";
import TopNavSubpage from "../../component/TopNav/TopNavSubpage";


class TermsAndCondition extends React.Component {
    render() {
        return (
            <div>
                <TopNavSubpage heading="Terms & Conditions" notify={false} wallet={false}/>
                <div className="terms-and-condition-component py-2 px-4">
                    <TermsAndConditionContent/>
                    <div className={"bottom-space"}/>

                    <MDBBox className="bottom-navbar">
                        <BottomNav/>
                    </MDBBox>
                </div>
            </div>

        );
    }
}

export default TermsAndCondition;
